import { render, staticRenderFns } from "./AssinarPrescricao.vue?vue&type=template&id=195db6af&"
import script from "./AssinarPrescricao.vue?vue&type=script&lang=js&"
export * from "./AssinarPrescricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports